var map = {
	"./btn_delete.svg": 126,
	"./btn_detail.svg": 3474,
	"./btn_disabled.svg": 1575,
	"./btn_down.svg": 8300,
	"./btn_edit.svg": 5936,
	"./btn_enable.svg": 749,
	"./btn_quxiaozhiding.svg": 9345,
	"./btn_reset.svg": 4755,
	"./btn_role.svg": 5413,
	"./btn_shangjia.svg": 2293,
	"./btn_shangyi.svg": 7579,
	"./btn_xiajia.svg": 4921,
	"./btn_xiayi.svg": 5136,
	"./btn_yulan.svg": 16,
	"./btn_zhiding.svg": 1549,
	"./eye-open.svg": 4301,
	"./eye.svg": 4986,
	"./file.svg": 7206,
	"./folder.svg": 5530,
	"./head_help.svg": 6521,
	"./head_home.svg": 4089,
	"./head_theme.svg": 4634,
	"./head_user.svg": 4106,
	"./lithologyImageFile2.svg": 9128,
	"./logout.svg": 5626,
	"./menu_baseSetting.svg": 7702,
	"./menu_chanpin.svg": 4085,
	"./menu_dongshihuichengyuan.svg": 3200,
	"./menu_fanzhanlicheng.svg": 6344,
	"./menu_guanwanguanli.svg": 4289,
	"./menu_hezuohuoban.svg": 8776,
	"./menu_mobanpeizhi.svg": 8918,
	"./menu_nianbao.svg": 5223,
	"./menu_qiyeshezhi.svg": 7210,
	"./menu_shouye.svg": 6533,
	"./menu_template.svg": 9230,
	"./menu_user.svg": 1706,
	"./menu_xinwen.svg": 5074,
	"./menu_zhaopin.svg": 3138,
	"./password2.svg": 9503,
	"./shouqi.svg": 1272,
	"./user.svg": 42
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7886;